import { Injectable } from '@angular/core';

@Injectable()
export class ColorHelper {
  public static hexToRGBA(color: string, alpha: number) {
    const [r, g, b] = color.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
